import { configureStore } from '@reduxjs/toolkit'

// Import new slice reducers
import catalogReducer from './slices/catalogSlice'
import customerReducer from './slices/customerSlice'
import energyReducer from './slices/energySlice'
import systemReducer from './slices/systemSlice'
import addonsReducer from './slices/addonsSlice'
import financialReducer from './slices/financialSlice'
import uiReducer from './slices/uiSlice'

// Import individual legacy reducers for backwards compatibility
// These will be phased out as components migrate to new slices
import agreement_confirmsend_reducer from '../reducers/agreement_confirmsend_reducer'
import agreementdata_reducer from '../reducers/agreementdata_reducer'
import birdprotection_confirmsend_reducer from '../reducers/birdprotection_confirmsend_reducer'
import conservation_area_reducer from '../reducers/conservation_area_reducer'
import customer_message_rep_reducer from '../reducers/customer_message_rep_reducer'
import customer2_email_reducer from '../reducers/customer2_email_reducer'
import customer2_name_reducer from '../reducers/customer2_name_reducer'
import customer2_surname_reducer from '../reducers/customer2_surname_reducer'
import customer2_title_reducer from '../reducers/customer2_title_reducer'
import deposit_reducer from '../reducers/deposit_reducer'
import elecrate_reducer from '../reducers/elecrate_reducer'
import electric_estimated_reducer from '../reducers/electric_estimated_reducer'
import fin_monthlypayment_reducer from '../reducers/fin_monthlypayment_reducer'
import fin_totalcost_reducer from '../reducers/fin_totalcost_reducer'
import listed_property_reducer from '../reducers/listed_property_reducer'
import mpan_number_reducer from '../reducers/mpan_number_reducer'
import noratedisclaimer_reducer from '../reducers/noratedisclaimer_reducer'
import offgrid_system_reducer from '../reducers/offgrid_system_reducer'
import panelArrays_reducer from '../reducers/panelArrays_reducer'
import propertytype_reducer from '../reducers/propertytype_reducer'
import save_redux_reducer from '../reducers/save_redux_reducer'

// Configure the store with new slices + legacy reducers
const store = configureStore({
    reducer: {
        // New consolidated slices
        catalog: catalogReducer,
        customer: customerReducer,
        energy: energyReducer,
        system: systemReducer,
        addons: addonsReducer,
        financial: financialReducer,
        ui: uiReducer,

        // Legacy reducers (for backwards compatibility during migration)
        // These match the keys from the old reducers/index.js
        agreement_confirmsend: agreement_confirmsend_reducer,
        agreementdata: agreementdata_reducer,
        birdprotection_confirmsend: birdprotection_confirmsend_reducer,
        conservation_area: conservation_area_reducer,
        customer_message_rep: customer_message_rep_reducer,
        customer2email: customer2_email_reducer,
        customer2name: customer2_name_reducer,
        customer2surname: customer2_surname_reducer,
        customer2title: customer2_title_reducer,
        deposit_amount: deposit_reducer,
        elecrate: elecrate_reducer,
        electric_estimated: electric_estimated_reducer,
        fin_monthlypayment: fin_monthlypayment_reducer,
        fin_totalcost: fin_totalcost_reducer,
        listed_property: listed_property_reducer,
        mpan_number: mpan_number_reducer,
        noratedisclaimer: noratedisclaimer_reducer,
        offgrid_system: offgrid_system_reducer,
        panelArrays: panelArrays_reducer,
        propertytype: propertytype_reducer,
        save_redux: save_redux_reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // Disable for complex objects
        }),
    devTools: process.env.NODE_ENV !== 'production'
})

export default store

// Re-export slice reducers (for advanced use cases)
export { default as catalogReducer } from './slices/catalogSlice'
export { default as customerReducer } from './slices/customerSlice'
export { default as energyReducer } from './slices/energySlice'
export { default as systemReducer } from './slices/systemSlice'
export { default as addonsReducer } from './slices/addonsSlice'
export { default as financialReducer } from './slices/financialSlice'
export { default as uiReducer } from './slices/uiSlice'

// Note: Actions and selectors should be imported directly from individual slices
// to avoid naming conflicts. Example:
// import { setElecConsumption, selectElecConsumption } from '../store/slices/energySlice'
